import { render, staticRenderFns } from "./ArticleManagementForm.vue?vue&type=template&id=44887065&"
import script from "./ArticleManagementForm.vue?vue&type=script&lang=js&"
export * from "./ArticleManagementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports